import { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { getByDotNotation } from "./utils.js";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		height: "100%",
		background: "white",
		color: theme.palette.primary.main,
		padding: "1%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
}));

const Value = ({
	itemWidth,
	itemHeight,
	variables,
	calculateFontSize,
	mode,
	liveVariables = {},
}) => {
	const classes = useStyles();
	const [displayString, setDisplayString] = useState("");
	const [liveDisplayString, setLiveDisplayString] = useState("");

	useEffect(() => {
		const unit = variables.unit?.value || "";
		const decimalPlaces = variables.decimal?.value || 1;
		const value = (Math.random() * 100).toFixed(decimalPlaces);
		const formattedValue = Number.parseFloat(value).toFixed(decimalPlaces);
		const newDisplayString = `${formattedValue}${unit}`;
		setDisplayString(newDisplayString);
	}, [variables]);

	useEffect(() => {
		const unit = variables.unit?.value || "";
		const decimalPlaces = variables.decimal?.value || 1;
		const value = getByDotNotation(liveVariables, variables?.variable?.value);
		if (value) {
			const formattedValue = Number.parseFloat(value).toFixed(decimalPlaces);
			const newLiveDisplayString = `${formattedValue}${unit}`;
			setLiveDisplayString(newLiveDisplayString);
		} else {
			const unitedValue = liveVariables[variables?.variable?.value];
			if (unitedValue) {
				const formattedValue = Number.parseFloat(unitedValue).toFixed(decimalPlaces);
				const newLiveDisplayString = `${formattedValue}${unit}`;
				setLiveDisplayString(newLiveDisplayString);
			} else {
				setLiveDisplayString("-");
			}
		}
	}, [liveVariables, variables]);

	return (
		<Grid
			item
			className={classes.root}
			style={{
				fontSize: calculateFontSize({
					width: itemWidth,
					height: itemHeight,
					text: displayString,
					minFontSize: 2,
					maxFontSize: 500,
				}),
			}}
		>
			{mode === "edit" && displayString}
			{mode === "view" && liveDisplayString}
		</Grid>
	);
};

export default Value;
